import { FC, InputHTMLAttributes } from 'react';
import classNames from 'classnames';

import classes from './switch.module.css';

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

export const Switch: FC<SwitchProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  className,
  'aria-label': ariaLabel,
  ...rest
}) => {
  return (
    <div className={classNames(classes.switchContainer, className)}>
      <label className={classes.switch}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          aria-label={ariaLabel || label}
          {...rest}
        />
        <span className={classes.slider}></span>
      </label>
      {label && <span className={classes.switchLabel}>{label}</span>}
    </div>
  );
};
